import { useFormat } from 'helpers/hooks/useFormat';

const ReservationFailedAlert: React.FC = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className="mb-8 border-l-4 border-red-500 bg-red-100 p-4 text-red-700" role="alert">
      <p>
        {formatMessage({
          id: 'error.reservationFailed',
          defaultMessage: "Errore durante l'aggiunta degli articoli. Riprova più tardi.",
        })}
      </p>
    </div>
  );
};

export default ReservationFailedAlert;
